import {
  Button,
  Card,
  Checkbox,
  Col,
  DatePicker,
  Form,
  Input,
  Row,
  Select,
  Space,
} from "antd";
import React, { useEffect, useState } from "react";
import { doc, updateDoc } from "firebase/firestore";
import { db } from "../../../../../../firebase";
import "./Profile.css";
import { bathRooms, bedRooms } from "../../../../../../utils/Util";
import { toast } from "react-hot-toast";
import moment from "moment";

function Profile({ id, companyName, data, setIsWait, isWait }) {
  const [edit, setEdit] = useState(false);

  const mainHeaderButtons = (
    <Space wrap>
      <Button
        type="link"
        onClick={() => {
          setEdit(!edit);
          setIsWait(false);
        }}
        style={{ paddingRight: 0 }}
      >
        {edit ? "Cancel" : "Edit"}
      </Button>
    </Space>
  );

  const [selectedPets, setSelectedPets] = useState([]);

  const handlePetsChange = (checkedValues) => {
    setSelectedPets(checkedValues);
  };

  const onFinish = (values) => {
    setIsWait(true);
    Object.keys(values).forEach((field) => {
      if (values[field] === undefined) {
        values[field] = "";
      }
    });

    const profile = {
      profile: {
        numberOfBedRooms: values.numberOfBedRooms,
        bathrooms: values.bathrooms,
        maxRent: values.maxRent,
        moveInDate: values.moveInDate
          ? values.moveInDate.format("YYYY-MM-DD")
          : "",
        additionalOccupants: values.additionalOccupants,
        monthlyIncome: values.monthlyIncome,
        creditStore: values.creditStore,
        pets: selectedPets,
      },
    };

    console.log("profile", profile);

    try {
      const guestCardRef = doc(db, "companies", companyName, "guestCards", id);
      updateDoc(guestCardRef, profile);
      setIsWait(true);
      setEdit(!edit);
      toast.success("success");
    } catch (err) {
      toast.error("error");
      console.log("error while updating", err);
      setIsWait(false);
    }
  };

  const onFinishFailed = (err) => {
    toast.error("Fields Required");
    console.log("error while updating", err);
    setIsWait(false);
  };

  // const defaultValues = {
  //   numberOfBedRooms: data?.numberOfBedRooms,
  //   maxRent: data?.maxRent ? data?.maxRent : "",
  // };

  const defaultValues = {
    pets: data?.pets,
    numberOfBedRooms: data?.numberOfBedRooms,
    maxRent: data?.maxRent,
    moveInDate: data?.moveInDate
      ? moment(data?.moveInDate, "DD-MM-YYYY")
      : null,
    creditStore: data?.creditStore,
    bathrooms: data?.bathrooms,
    additionalOccupants: data?.additionalOccupants,
    monthlyIncome: data?.monthlyIncome,
  };
  const [form] = Form.useForm();
  useEffect(() => {
    form.setFieldsValue({
      ...defaultValues,
      moveInDate: defaultValues.moveInDate
        ? moment(defaultValues.moveInDate, "DD-MM-YYYY")
        : null,
    });
  }, [data]);
  return (
    <>
      <Card
        title="Profile"
        bordered={false}
        style={{ paddingBottom: 10 }}
        extra={mainHeaderButtons}
      >
        <Form
          name="basic"
          labelCol={{ span: 7 }}
          initialValues={defaultValues}
          className="form-container"
          colon={false}
          onFinish={onFinish}
          onFinishFailed={onFinishFailed}
          form={form}
        >
          {edit ? (
            <Row>
              <Col span={24}>
                <Form.Item
                  label="Bedrooms"
                  wrapperCol={{ span: 8 }}
                  name="numberOfBedRooms"
                >
                  <Select>
                    {bedRooms.map((bedRooms) => {
                      return (
                        <Select.Option key={bedRooms} value={bedRooms}>
                          {bedRooms}
                        </Select.Option>
                      );
                    })}
                  </Select>
                </Form.Item>

                <Form.Item
                  label="Bathrooms"
                  wrapperCol={{ span: 8 }}
                  name="bathrooms"
                >
                  <Select>
                    {bathRooms.map((bathRooms) => {
                      return (
                        <Select.Option key={bathRooms} value={bathRooms}>
                          {bathRooms}
                        </Select.Option>
                      );
                    })}
                  </Select>
                </Form.Item>

                <Form.Item
                  label="Max Rent"
                  wrapperCol={{ span: 8 }}
                  name="maxRent"
                >
                  <Input />
                </Form.Item>

                <Form.Item
                  label="Move In"
                  wrapperCol={{ span: 8 }}
                  name="moveInDate"
                >
                  <DatePicker style={{ width: "100%" }} />
                </Form.Item>

                <Form.Item
                  label="Additional Occupants"
                  wrapperCol={{ span: 8 }}
                  name="additionalOccupants"
                >
                  <Input />
                </Form.Item>

                <Form.Item
                  label="Monthly Income"
                  wrapperCol={{ span: 8 }}
                  name="monthlyIncome"
                >
                  <Input prefix="$" />
                </Form.Item>

                <Form.Item
                  label="Credit Score"
                  wrapperCol={{ span: 8 }}
                  name="creditStore"
                >
                  <Input />
                </Form.Item>

                <Form.Item label="Pets" wrapperCol={{ span: 8 }} name="pets">
                  <Checkbox.Group onChange={handlePetsChange}>
                    <Checkbox value="Cat">Cat</Checkbox>
                    <Checkbox value="Dog">Dog</Checkbox>
                    <Checkbox value="Other">Other</Checkbox>
                  </Checkbox.Group>
                </Form.Item>
              </Col>

              <div className="form-action page-actions-container">
                <Button type="primary" htmlType="submit" loading={isWait}>
                  {isWait ? "please wait..." : "Save"}
                </Button>
                <Button
                  onClick={() => {
                    setEdit(!edit);
                  }}
                >
                  Cancel
                </Button>
              </div>
            </Row>
          ) : (
            <>
              <Row>
                <Col span={24} className="profileCol">
                  <Form.Item label="Beds / Baths">
                    <p>
                      {data?.numberOfBedRooms}BR / {data?.bathrooms}BA
                    </p>
                  </Form.Item>

                  <Form.Item label="Max Rent" style={{ paddingTop: 0 }}>
                    <p>${data?.maxRent}</p>
                  </Form.Item>

                  <Form.Item label="Desired Move In">
                    <p>{data?.moveInDate}</p>
                  </Form.Item>

                  <Form.Item label="Additional Occupants">
                    <p>{data?.additionalOccupants}</p>
                  </Form.Item>

                  <Form.Item label="Pets">
                    <ul>
                      {data?.pets?.map((item) => (
                        <li key={item}>{item}</li>
                      ))}
                    </ul>
                  </Form.Item>

                  <Form.Item label="Monthly Income">
                    <p>$ {data?.monthlyIncome}</p>
                  </Form.Item>

                  <Form.Item label="Credit Score">
                    <p>{data?.creditStore}</p>
                  </Form.Item>
                </Col>
              </Row>
            </>
          )}
        </Form>
      </Card>
    </>
  );
}

export default Profile;
